/**
 * Cache em memória das URLs de imagens já carregadas na sessão.
 * Evita o "flash" do skeleton quando uma imagem já está no cache do navegador
 * ou já foi exibida em outro componente.
 */
const loadedImages = new Set<string>();

export function markImageLoaded(src: string) {
  if (src) loadedImages.add(src);
}

export function isImageLoaded(src: string): boolean {
  if (!src) return false;
  if (loadedImages.has(src)) return true;
  // Verifica cache do browser via Image() — síncrono se já estiver em cache
  if (typeof window !== 'undefined') {
    try {
      const img = new Image();
      img.src = src;
      if (img.complete && img.naturalWidth > 0) {
        loadedImages.add(src);
        return true;
      }
    } catch {
      /* noop */
    }
  }
  return false;
}
